import { createContext, useContext, type ReactNode } from "react";
import { useAuth } from "@/hooks/useAuth";
import { useLayoutVersionQuery, type LayoutVersion } from "@/hooks/useLayoutVersion";

const LayoutVersionContext = createContext<LayoutVersion>("loading");

/** Fica abaixo do `AuthProvider`: uma leitura da chave por organização para todas as rotas (D2). */
export function LayoutVersionProvider({ children }: { children: ReactNode }) {
  const { user, isLoading, isDetailsLoaded, tenantId } = useAuth();
  // Espera o tenantId do perfil (senão piscaria o legado). Deslogado → legado; o AppRoute manda para /login.
  const ready = !isLoading && (user === null || isDetailsLoaded);
  const version = useLayoutVersionQuery(user === null ? null : tenantId, ready);
  return <LayoutVersionContext.Provider value={version}>{children}</LayoutVersionContext.Provider>;
}

export function useLayoutVersion(): LayoutVersion {
  return useContext(LayoutVersionContext);
}
